import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ZakatClaim = () => {
  const location = useLocation();
  const { zakatAmount, recipientZakatAddress, formData, eligible } = location.state || {};

  return (
    <div className="zakat-claim-page">
      <h1>Zakat Claim Form</h1>
      {eligible ? (
        <div>
          <h2>Eligibility Confirmed!</h2>
          <p>Amount: {zakatAmount} BAIT</p>
          <p>Recipient Address: {recipientZakatAddress}</p>
        </div>
      ) : (
        <p>You are not eligible for Zakat.</p>
      )}
      {/* You can render more details based on your needs */}
    </div>
  );
};

export default ZakatClaim;
